<template>
    <div class="flex p-5 w-full">
        <meeting-form2 class="flex w-full" :show-required="false" :show-type="false"></meeting-form2>
    </div>
</template>

<script>
import MeetingForm2 from '@/features/meetings/MeetingForm2.vue';
export default {
    components: {
        MeetingForm2,
    },
};
</script>
